import { Fragment, PropsWithChildren } from 'react';
import { useMount } from '@cutwise/react-utils';

import AppError, { CODE_ACCESS_UNAUTHORIZED } from '../../state/AppError';

function ErrorChecker({ children }: PropsWithChildren<unknown>) {
  useMount(() => {
    const errorData = window.CUTWISE_FORCE_ERROR;

    window.CUTWISE_FORCE_ERROR = null;

    if (errorData && errorData.code !== CODE_ACCESS_UNAUTHORIZED) {
      throw AppError.createErrorFromBackend(errorData);
    }
  });

  return <Fragment>{children}</Fragment>;
}

export default ErrorChecker;
